@for (_ of [].constructor(bones); track _) {
  <div class="bone">
    <div class="heading"></div>
    <div class="text"></div>
    <div class="text"></div>
  </div>
}
